import { PageType } from "@reconvert/reconvert-utils"

export const getkeysArray = (operator: string) => {
    switch (operator) {
      case PageType.CHECKOUT:
        return [PageType.CHECKOUT];
      case PageType.POST_PURCHASE_PAGE1:
        return [PageType.POST_PURCHASE_PAGE1];
      case PageType.POST_PURCHASE_PAGE2:
        return [PageType.POST_PURCHASE_PAGE2];
      case PageType.THANK_YOU_PAGE:
        return [PageType.THANK_YOU_PAGE];
      case PageType.ORDER_STATUS_PAGE:
        return [PageType.ORDER_STATUS_PAGE];
      case `${PageType.POST_PURCHASE_PAGE1}-${PageType.POST_PURCHASE_PAGE2}`:
      case `${PageType.POST_PURCHASE_PAGE1}&${PageType.POST_PURCHASE_PAGE2}`:
        return [PageType.POST_PURCHASE_PAGE1, PageType.POST_PURCHASE_PAGE2];
      default:
        return [];
    }
  }

/** Page-selector operator from a persisted PREV_PAGE_OFFER sub-rule (never the engine operator). */
export function resolvePrevPageOfferOperatorFromSubRule(sub: {
  operator?: string;
  value?: unknown;
  extraFields?: Record<string, unknown>;
} | undefined): string {
  if (!sub) return "";
  const extra = sub.extraFields || {};
  const candidates = [extra.operatorValue, extra.condition];
  for (const candidate of candidates) {
    if (typeof candidate === "string" && getkeysArray(candidate).length > 0) {
      return candidate;
    }
  }
  const first = Array.isArray(sub.value) ? String(sub.value[0] ?? "") : String(sub.value ?? "");
  const page = first.split("|")[0];
  if (page && getkeysArray(page).length > 0) {
    return page;
  }
  if (typeof sub.operator === "string" && getkeysArray(sub.operator).length > 0) {
    return sub.operator;
  }
  return "";
}

/**
 * IDs currently selected on a PREV_PAGE_OFFER sub-rule.
 * Matches validateConditionData `items: extraFields.conditionIds.value`.
 * ANY means every previous-page condition — don't pre-check the expanded list.
 */
export function selectedIdsFromPrevPageOfferSubRule(sub: {
  value?: unknown;
  extraFields?: Record<string, unknown>;
} | undefined): string[] {
  if (!sub) {
    return [];
  }
  const extra = sub.extraFields && typeof sub.extraFields === "object" ? sub.extraFields : {};
  const shaped = extra.conditionIds as { key?: string; value?: unknown } | undefined;
  const key = String(shaped?.key || extra.condition_selection || "").toUpperCase();
  if (key === "ANY") {
    return [];
  }
  const unique = (ids: unknown[]): string[] =>
    Array.from(new Set(
      ids
        .map((id) => {
          const raw = String(id || "").trim();
          return raw.includes("|") ? (raw.split("|").pop() || "").trim() : raw;
        })
        .filter(Boolean),
    ));
  if (Array.isArray(shaped?.value) && shaped.value.length) {
    return unique(shaped.value);
  }
  const extraIds = extra.condition_ids;
  if (Array.isArray(extraIds) && extraIds.length) {
    return unique(extraIds);
  }
  const values = Array.isArray(sub.value) ? sub.value : [];
  const parsed = values
    .map((raw) => String(raw ?? ""))
    .filter((value) => value.includes("|"))
    .map((value) => (value.split("|").pop() || "").trim())
    .filter(Boolean);
  return unique(parsed);
}
  
export const handleFilterCondition = (data: any, operator: string) => {
    return getkeysArray(operator).includes(data.location as PageType);
}